// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export const ScheduleDate = styled.h5({
	font: token('font.heading.xsmall'),
	margin: `0 0 0 ${token('space.100', '8px')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const RangeContainer = styled.div({
	display: 'flex',
	alignItems: 'center',
	margin: `0 ${token('space.100', '8px')} 0 0`,
});

export const periodSelectStyles = {
	marginRight: token('space.100', '8px'),
	// TODO: remove width after ‘@atlaskit/Select’ upgrade
	maxWidth: '110px',
	minWidth: '110px',
	width: '110px',
};

export const viewSelectStyles = {
	// TODO: remove width after ‘@atlaskit/Select’ upgrade
	maxWidth: '150px',
	minWidth: '150px',
	width: '150px',
};
